export default "__VITE_ASSET__7e773d3f__"